exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .btn-group-1 .btn{margin-bottom:15px}.modal .modal-dialog.preview-popup{width:770px}@media (max-width: 800px){.modal .modal-dialog.preview-popup{width:100%}}@media (max-width: 768px){.modal .modal-dialog.preview-popup{margin-left:auto}}.modal .modal-dialog.simulateModalDialog{width:1090px;transform:translateY(-50%)}.modal .modal-dialog.simulateModalDialog .modal-header{padding:20px 30px;position:relative}.modal .modal-dialog.simulateModalDialog .d3LegendContainer{margin:5px 0px 2px 0px}@media (max-width: 1090px){.modal .modal-dialog.simulateModalDialog{width:100%}}@media (max-width: 767px){.modal .modal-dialog{margin-top:60px}}@media (min-width: 768px){.modal .modal-dialog{position:absolute;left:0;right:0;top:50%;transform:translateY(-52%);margin:0 auto}}@media (min-width: 1367px){.modal .modal-dialog{transform:translateY(-55%)}}.modal-header{padding:30px;border:0}.modal-header h4.modal-title{font-size:24px;color:#4c4c4c;text-align:center}.modal-header h3.modal-title{color:#4c4c4c}.modal-body{padding:0px 30px}.modal-footer{padding:30px;border:0}.modal-footer .btn-group-1 .btn{margin-bottom:0}.modal{background:rgba(0,0,0,0.6)}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.scss
// module id = 1098
// module chunks = 0 1 2 3 4 5 6 7